
export  const  onlypositivenumbers = (val) => { if (val === '') return val;  const i = parseInt(val); return (!isNaN(i) && i > 0) ? i : 1; }
//export const onlypositivenumbers = (val) =>  /^\+?(0|[1-9]\d*)$/.test(val)



// WEBPACK FOOTER //
// ./src/utils/helperfunctions/onlypositivenumbers.js